import { Injectable } from '@angular/core';
import { Observable, of, map, catchError } from 'rxjs';
import { IArea } from '@newroom-connect/library/interfaces';

import { CacheStoreConfig } from '../models/cache-models';

import { AbstractCacheStore } from './abstract-cache-store';

/**
 * Store configuration for areas.
 */
const AREA_STORE_CONFIG: CacheStoreConfig = {
  storeName: 'areas',
  keyPath: 'id',
  topic: 'areas',
  projectKeyPath: 'projectId',
  indices: [
    { name: 'projectId', keyPath: 'projectId' },
    { name: 'slug', keyPath: 'slug', options: { unique: true } },
    { name: 'timestamp', keyPath: 'timestamp' }
  ],
  version: '1'
};

/**
 * Cache store specifically for area data.
 */
@Injectable({
  providedIn: 'root'
})
export class AreaCacheStore extends AbstractCacheStore<IArea> {
  constructor() {
    super(AREA_STORE_CONFIG);
  }

  /**
   *
   * @param slug Slug of the area to retrieve.
   * @param projectId Project ID for the area.
   * @returns Observable of area or null if not found.
   */
  public override getBySlug(slug: string, projectId: string): Observable<IArea | null> {
    return this.getByIndex<IArea>('slug', slug).pipe(
      map(areas => {
        // Filter areas by project ID
        const projectAreas = areas.filter(area => area.projectId === projectId);

        return projectAreas.length > 0 ? projectAreas[0] : null;
      }),
      catchError(error => {
        this.logger.error(`Error getting area by slug ${slug}:`, error);
        return of(null);
      })
    );
  }
}
